/**
 * @desc 调拨入库完结
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.allocationMasterFacadeImpl.allocationFinish.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/allocationMaster/allocationMaster/allocationFinish`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
